<template>
  <div
    :class="
      isBlueTheme
        ? 'text-white bg-gradient-to-t from-blueG0 to-blueG2 shadow-[0px_4px_44px_0px_rgba(178,178,178,0.16)]'
        : 'text-darkBlueG0 bg-grayG3'
    "
    class="min-w-67.5 max-w-67.5 rounded-xl flex flex-col items-stretch justify-between px-5 pt-11 pb-8 text-left"
  >
    <div class="mb-7 flex flex-col items-start justify-start gap-6">
      <div class="text-sm font-extrabold">
        {{ $t(title) }}
      </div>
      <div class="flex flex-col items-start justify-start gap-5">
        <div v-for="verifyItem in formattedVerifyList" :key="verifyItem.id">
          <div
            :class="[
              verifyItem.isHide ? 'hidden md:flex md:invisible' : 'flex',
              isBlueTheme ? 'text-white' : 'text-darkBlueG0'
            ]"
            class="items-center justify-start gap-2"
          >
            <i v-if="verifyItem.condition" class="el-icon-success text-greenG0 text-xs flex-none" />
            <svg-icon v-else iconName="timer-icon" className="!w-3 !h-3 flex-none" />
            <div class="text-sm font-semibold">
              {{
                verifyItem.isVerifiedItem
                  ? verifyItem.condition
                    ? $t('verificationStatus.kyc.verified')
                    : $t('verificationStatus.kyc.notVerified')
                  : $t(verifyItem.title)
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="md:min-h-66.5 flex flex-col items-start justify-between">
      <el-button class="white_button !bg-white" :disabled="kycStatus !== KycStatus.active" @click="verifyButtonOnClick">
        {{
          kycStatus === KycStatus.inProgress
            ? $t('verificationStatus.kyc.verifyInProgress')
            : kycStatus === KycStatus.completed
            ? $t('verificationStatus.kyc.verificationCompleted')
            : $t('common.button.verifyNow')
        }}
        <el-tooltip v-if="verifyButtonTip && verifyButtonTip.length > 0" placement="top">
          <template #content
            ><div class="max-h-41 overflow-y-auto whitespace-pre-line">
              {{ $t(verifyButtonTip) }}
            </div></template
          >
          <svg-icon iconName="info-circle-icon" className="tooltip-icon" />
        </el-tooltip>
      </el-button>
      <el-divider class="my-7 h-0 border-t border-t-dashed opacity-20" />
      <div class="flex flex-col items-start justify-start gap-5">
        <div
          v-for="permissionItem in Object.values(KycPermission)"
          :key="permissionItem.key"
          class="flex items-start justify-start gap-3"
          :class="permissionKeys.includes(permissionItem.key) ? 'opacity-100' : 'opacity-25'"
        >
          <svg-icon
            :iconName="permissionItem.icon"
            :className="`${isBlueTheme ? 'text-white' : 'text-blueG0'} !h-7 !w-7`"
          />
          <div :class="isBlueTheme ? 'text-white' : 'text-darkBlueG0'" class="text-sm font-semibold">
            {{ $t(permissionItem.title) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SvgIcon from '../SvgIcon.vue';

export const KycPermissionKey = Object.freeze({
  mtAccount: 'mtAccount',
  deposit: 'deposit',
  trade: 'trade',
  withdrawal: 'withdrawal'
});

export const KycStatus = Object.freeze({
  active: 'active',
  inProgress: 'inProgress',
  completed: 'completed',
  disabled: 'disabled'
});

export default {
  components: { SvgIcon },
  name: 'KycStatusCard',
  props: {
    // KycStatus
    kycStatus: { type: String, required: true },
    title: { type: String, required: true },
    // Array<{condition: true, title: "", isHide:false, isVerifiedItem: true}>
    verifyList: { type: Array, required: true },
    // Array<KycPermissionKey>
    permissionKeys: { type: Array, required: true },
    verifyButtonOnClick: { type: [Function, null], default: null },
    verifyButtonTip: { type: String, default: '' },
    // For align multiple Cards' section in same alignment
    verifyListMaxLength: { type: [Number, null], default: null },
    isBlueTheme: { type: Boolean, default: false }
  },
  computed: {
    formattedVerifyList() {
      return this.verifyListMaxLength !== null
        ? Array.from(
            { length: this.verifyListMaxLength },
            (_, i) => this.verifyList[i] || { condition: true, title: '', isHide: true, isVerifiedItem: false }
          )
        : this.verifyList;
    }
  },
  created() {
    this.KycStatus = KycStatus;
    const getPermissionObject = key => {
      switch (key) {
        case KycPermissionKey.mtAccount:
          return {
            title: 'verificationStatus.kyc.mt4Mt5Account',
            icon: 'register-mt-account-icon'
          };
        case KycPermissionKey.deposit:
          return {
            title: 'verificationStatus.kyc.deposit',
            icon: 'register-deposit-icon'
          };
        case KycPermissionKey.trade:
          return {
            title: 'verificationStatus.kyc.trade',
            icon: 'register-trade-icon'
          };
        case KycPermissionKey.withdrawal:
          return {
            title: 'verificationStatus.kyc.withdrawal',
            icon: 'register-withdrawal-icon'
          };
        default:
          break;
      }
    };
    this.KycPermission = Object.keys(KycPermissionKey).reduce((acc, key) => {
      return { ...acc, [key]: { key: key, ...getPermissionObject(key) } };
    }, {});
  }
};
</script>
